import { SHARED_AUTH_ENGOO, SHARED_STATE_REPLACE } from 'app/services/cookies/constants';
import { ICookieTokenInfo, ICookieInteractions, ICookieContext } from 'app/services/cookies/index';
import Cookies from 'js-cookie';
import { AppDispatch } from 'redux';
import { clearCookie, setCookie, checkForCookieMismatch } from './cookie';
import { BrandContextValue } from 'app/components/OrganizationContext';

const STATE_EXPIRES_IN = 7 * 24 * 60 * 60 * 1000;

export interface ISharedState {
  profileUpdated: Date;
}

const makeSetAuthCookie = (context: ICookieContext) => (userId: string, token: ICookieTokenInfo) =>
  async (dispatch: AppDispatch) => {
    setCookie({
      key: SHARED_AUTH_ENGOO,
      value: userId,
      context,
    });
  };

const checkAuthCookie = (newValue: string) => async (dispatch: AppDispatch) => {
  const previousValue = Cookies.get(SHARED_AUTH_ENGOO);
  return await dispatch(checkForCookieMismatch(previousValue, newValue));
};

export const setProfileUpdateNowForBrand = (brand: BrandContextValue) => {
  const setProfileUpdatedNow = makeSetProfileUpdatedNow({
    isFirstParty: brand.isFirstParty,
    isFirstPartyDmm: brand.firstPartyDmm,
    defaultDomain: brand.defaultDomain,
  });
  // This function is curried so that we can expose the configured version through
  // the context if we ever need to.
  setProfileUpdatedNow();
};

export const makeSetProfileUpdatedNow = (context: ICookieContext) => {
  const setStateCookie = makeSetStateCookie(context);
  return () => {
    setStateCookie({ profileUpdated: new Date() });
  };
};

export const makeSetStateCookie = (context: ICookieContext) => (state: ISharedState) => {
  const now = new Date();
  const expires = new Date(now.getTime() + STATE_EXPIRES_IN);
  setCookie({
    key: SHARED_STATE_REPLACE,
    value: state,
    options: { expires },
    context,
  });
};

export const makeEngooCookieInteractions = (context: ICookieContext): ICookieInteractions => ({
  cleanCookieData: () => (dispatch) => {
    clearCookie({
      context,
      key: SHARED_AUTH_ENGOO,
    });
    clearCookie({
      context,
      key: SHARED_STATE_REPLACE,
    });
  },
  setAuthCookie: makeSetAuthCookie(context),
  checkAuthCookie,
  clearSharedCookie: () => clearCookie({ context, key: SHARED_STATE_REPLACE }),
});
